import React from "react";

export const Header = () => {
  return <h1>New albums &amp; singles</h1>;
};
